<template>
  <div class="w100 Overview">
    <div class="search-top" v-loading="Loading">
      <div>
        <el-input
          style="width: 260px; margin-left: 10px"
          clearable
          v-model="searchData.Name"
          placeholder="请输入供应商/生产厂家/维修商名称"
        ></el-input>
        <el-input
          style="width: 260px; margin-left: 10px"
          clearable
          v-model="searchData.DeviceName"
          placeholder="请输入设备名称/编号"
        ></el-input>
        <el-button
          type="primary"
          @click="getDataList"
          style="margin-left: 10px"
        >
          查询</el-button
        >
      </div>
    </div>
    <el-table
      class="table-ove"
      :data="Data"
      style="width: 100%"
      header-row-class-name="table-tit"
      v-loading="Loading"
    >
      <el-table-column
        type="index"
        label="序号"
        width="55"
        align="center"
      ></el-table-column>
      <el-table-column prop="device_no" label="设备编号" align="center" />
      <el-table-column prop="device_name" label="设备名称" align="center" />
      <el-table-column prop="cVenName" label="供应商名称" align="center" />
      <el-table-column
        prop="cVenPerson"
        label="供应商联系人"
        align="center"
        width="110"
      />
      <el-table-column prop="cVenPhone" label=" 供应商电话" align="center" />
      <el-table-column
        prop="manufacturer"
        label="生产厂家名称"
        align="center"
      />
      <el-table-column
        prop="manufacturercontacts"
        label="生产厂家联系人"
        align="center"
        width="120"
      />
      <el-table-column
        prop="manufacturerPhone"
        label=" 生产厂家电话"
        align="center"
      />
      <el-table-column prop="maintenance" label="维修商名称" align="center" />
      <el-table-column
        prop="maintenancecontacts"
        label="维修商联系人"
        align="center"
        width="110"
      />
      <el-table-column prop="Phone" label="维修商电话" align="center" />
    </el-table>
  </div>
</template>
<script>
import * as echarts from 'echarts'

export default {
  data() {
    return {
      Loading: false,
      Data: [],
      searchData: {
        DeviceName: '',
        Name: '',
      },
    }
  },
  props: {
    pId: {
      type: String,
      default: '',
    },
  },
  components: {},
  methods: {
    rowName(obj) {
      if (obj.row.Leve == 1) {
        return 'level1'
      }
    },
    getDataList() {
      this.Loading = true
      this.$http
        .post(`/Base_ProjectWork/Base_ProjectSupplier/GetSupplierContactList`, {
          SortField: 'SupplierId',
          SortType: 'asc',
          Search: [
            {
              Condition: 'ProjectId',
              Keyword: this.pId,
            },
            {
              Condition: 'DeviceName',
              Keyword: this.searchData.DeviceName,
            },
            {
              Condition: 'Name',
              Keyword: this.searchData.Name,
            },
          ],
        })
        .then((res) => {
          this.Loading = false
          if (res.Success) {
            this.Data = res.Data || []
          }
        })
    },

    createGaugeChart(containerId, value, color) {
      const container = document.getElementById(containerId)
      if (!container) return

      const chart = echarts.init(container)
      const option = {
        series: [
          {
            type: 'gauge',

            min: 0,
            max: 100,
            //分割数
            splitNumber: 5,
            radius: '90%',
            center: ['50%', '50%'],
            progress: {
              show: true,
              width: 6,
              itemStyle: {
                color: color,
              },
              roundCap: true,
            },
            axisLine: {
              lineStyle: {
                width: 6,
              },
            },
            // 刻度样式。
            axisTick: {
              show: true,
              distance: 1,
              length: 1,
              lineStyle: {
                width: 1,
                color: '#999',
              },
            },
            splitLine: {
              distance: 1,
              show: true,
              length: 0,
              lineStyle: {
                width: 1,
                color: '#999',
              },
            },
            axisLabel: {
              distance: 7,
              color: '#999',
              fontSize: 8,
            },
            pointer: {
              width: 3,
              length: '70%',
              itemStyle: {
                color: color,
              },
            },
            detail: {
              formatter: '{value}%',
              textStyle: {
                fontSize: 12,
                color: '#333',
              },
              offsetCenter: [0, 12],
            },
            data: [
              {
                value: value || 0,
              },
            ],
          },
        ],
      }

      chart.setOption(option)
      chart.resize()
    },
  },
  mounted() {
    // this.initCharts()
  },
  created() {
    this.getDataList()
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .table-tit {
  font-weight: 1000;
  font-size: 16px;
  color: #000;
  height: 40px;
}
.table-ove {
  margin-bottom: 20px;
}
.Overview {
  padding: 0 10px;
}
::v-deep .el-table__body-wrapper {
  .el-table__cell {
    font-size: 14px;
  }
}
::v-deep .level1 {
  font-size: 14px;
  color: #000;
  font-weight: bold;
}
</style>
